import api from '@http/api';
import { FormatDate } from '@src/utils/formats';

export interface IGetAllProgramasTable {
  //modelo: ISolicitacaoResultTable[];
  id: number;
  nome: string;
  dataCadastro: string;

}

export interface ISolicitacaoResultTable {
  id_correspondencia_devolvida: string;
}

export interface IGetAllProgramas {

  error: boolean;
  response?: IGetAllProgramasTable[];
  //modelo: IGetAllProgramasTable[];
}

export interface IRequestPrograma {
  nome: string;
}

export interface IDesativarPrograma {
  id: number;
}

class Services {
  public async CreatePrograma(data: IRequestPrograma) {
    return await api
      .post('/api/Programa/Create', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }


  public async DesativarPrograma({ id }: IDesativarPrograma) {
    return await api
      .delete(`/api/Programa/Delete/${id}`)

      .then(response => {
        return {
          error: false,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }


}

export default Services;
